import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {textEllipsis} from '@travel-frontend/ui-components';

export const Subtitle = styled.div(
  ({theme}) => css`
    color: ${theme.colors.contentSecondary};
    ${theme.typography.labelSmall};
    ${textEllipsis};

    ${theme.respondTo(
      'lg',
      css`
        ${theme.typography.labelMedium};
      `
    )}
  `
);
